




















import { Component, Mixins, Prop } from 'vue-property-decorator'
import CoresDoPainel from './CoresDoPainel'
import EtiquetaPequena from './EtiquetaPequena.vue'
import type { TopPecaDoCliente } from '@/models'
import { corDoTom, valorOuSemDados } from '@/shareds/painel-do-cliente-shareds'
import { nomeDaPeca, textoDasVezes, textoDosSkus } from '@/shareds/painel-do-cliente-mix-shareds'

@Component({
	components: {
		EtiquetaPequena,
	},
})
export default class ItemDeTopPeca extends Mixins(CoresDoPainel) {
	@Prop({ type: Object, required: true }) peca!: TopPecaDoCliente

	fotoComErro = false

	get corCinza() {
		return this.corLegivel(corDoTom('cinza', this.corPrimaria))
	}

	get mostrarFoto() {
		return !!this.peca.foto && !this.fotoComErro
	}

	get nome() {
		return nomeDaPeca(this.peca)
	}

	get skus() {
		return textoDosSkus(this.peca)
	}

	get categoria() {
		return valorOuSemDados(this.peca.categoria)
	}

	get estacao() {
		return valorOuSemDados(this.peca.estacao)
	}

	get vezes() {
		return textoDasVezes(this.peca)
	}
}
